// extracted by mini-css-extract-plugin
export default {"deliveryBlockTemplateHeader":"delivery-block-template-header_deliveryBlockTemplateHeader__tifQ4"};